import Http from '../common/http';

const AuthService = {
  login(username, password) {
    return Http.post('/auth/token', {
      username,
      password,
    }, true);
  },
};

export default AuthService;
